import { HEADER_LOGO } from "../constants/index";

const initial_state = {
  headerLogo: null,
};

const Projects = (state = initial_state, action) => {
  switch (action.type) {
    case HEADER_LOGO:
      return {
        ...state,
        headerLogo: action.payload,
      };
    default:
      return state;
  }
};

export default Projects;
